import HomePage from './components/Home/HomePage';
import SigninPage from './components/Account/SigninPage';
import { AuthRoutes, PublicRoutes, RouteNames } from './enums/RouteEnums';
import SignupPage from './components/Account/SignupNew/SignupPageNew';
import ResetPass from './components/Account/ResetPassword';
import EmailConfirm from './components/Account/ConfirmEmail';
import ContactUs from './components/Footer/ContactUs';
import WalletOverview from './components/Wallet/WalletOverview';
import MyAccount from './components/Profile/MyAccountOverview';
import GamesPage from './components/Games/GamesPage';
import GameWindow from './components/Games/GameWindow';
import NotFound from './components/Common/NotFound';
import PromotionPage from './components/Promotions/PromotionsPage';
import TournamentsPage from './components/Tournaments/TournamentsPage';
import ChallengesPage from './components/Challenges/ChallengesPage';
import Shop from './components/Shop/ShopPage';
import Bonuses from './components/Bonuses/BonusOverview';
import LandingPage from './components/LandingPage/LandingPage';
import LandingPageNotFound from './components/Common/LandingPageNotFound/LandingPageNotFound';
import SigninPageNew from './components/Account/SigninNew/SigninPageNew';

export interface IRouteModel {
  id?: number;
  name: string;
  path: string;
  Component: React.FunctionComponent;
  requiredRole?: string | null;
  isPublic: boolean;
  showOnClone: boolean;
}

const Routes: IRouteModel[] = [
  {
    name: RouteNames.Home,
    path: PublicRoutes.Home,
    Component: HomePage,
    isPublic: true,
    showOnClone: true
  },
  {
    name: RouteNames.Signin,
    path: PublicRoutes.Signin,
    Component: SigninPageNew,
    isPublic: true,
    showOnClone: true
  },
  {
    name: RouteNames.Signup,
    path: PublicRoutes.Signup,
    Component: SignupPage,
    isPublic: true,
    showOnClone: true
  },
  {
    name: RouteNames.ResetPass,
    path: PublicRoutes.ResetPass,
    Component: ResetPass,
    isPublic: true,
    showOnClone: true
  },
  {
    name: RouteNames.ConfirmEmail,
    path: PublicRoutes.ConfirmEmail,
    Component: EmailConfirm,
    isPublic: true,
    showOnClone: true
  },
  {
    name: RouteNames.ContactUs,
    path: PublicRoutes.ContactUs,
    Component: ContactUs,
    isPublic: true,
    showOnClone: true
  },
  {
    name: RouteNames.Wallet,
    path: AuthRoutes.Wallet,
    Component: WalletOverview,
    isPublic: false,
    showOnClone: true
  },
  {
    name: RouteNames.MyAccount,
    path: AuthRoutes.MyAccount,
    Component: MyAccount,
    isPublic: false,
    showOnClone: true
  },
  {
    name: RouteNames.Games,
    path: PublicRoutes.Games,
    Component: GamesPage,
    isPublic: true,
    showOnClone: true
  },
  {
    name: RouteNames.Game,
    path: AuthRoutes.Game,
    Component: GameWindow,
    isPublic: false,
    showOnClone: true
  },
  {
    name: RouteNames.Bonuses,
    path: AuthRoutes.Bonuses,
    Component: Bonuses,
    isPublic: false,
    showOnClone: true
  },
  {
    name: RouteNames.NotFound,
    path: PublicRoutes.NotFound,
    Component: NotFound,
    isPublic: true,
    showOnClone: true
  },
  {
    name: RouteNames.Promotions,
    path: PublicRoutes.Promotions,
    Component: PromotionPage,
    isPublic: true,
    showOnClone: true
  },
  {
    name: RouteNames.Tournaments,
    path: PublicRoutes.Tournaments,
    Component: TournamentsPage,
    isPublic: true,
    showOnClone: false
  },
  {
    name: RouteNames.Challenges,
    path: PublicRoutes.Challenges,
    Component: ChallengesPage,
    isPublic: true,
    showOnClone: false
  },
  {
    name: RouteNames.Shop,
    path: PublicRoutes.Shop,
    Component: Shop,
    isPublic: true,
    showOnClone: false
  },
  {
    name: RouteNames.LandingPage,
    path: PublicRoutes.LandingPage,
    Component: LandingPage,
    isPublic: true,
    showOnClone: false
  },
  {
    name: RouteNames.LandingPageNotFound,
    path: PublicRoutes.LandingPageNotFound,
    Component: LandingPageNotFound,
    isPublic: true,
    showOnClone: false
  }
];

export const getRoutes = (): IRouteModel[] => {
  let index = 0;
  const result: IRouteModel[] = [];
  const isClone = process.env.ENVIRONMENT === 'licence';

  if (isClone) {
    Routes.filter((r) => r.showOnClone).forEach((r: IRouteModel) => {
      result.push({ id: index++, ...r });
    });
  } else {
    Routes.forEach((r: IRouteModel) => {
      result.push({ id: index++, ...r });
    });
  }
  return result;
};
